module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [(!_vm.web3) ? _c('div', [_vm._v("\n    web3 not found. please install the metamask plugin or use the Mist browser.\n  ")]) : (!['rinkeby', 'other'].includes(_vm.network)) ? _c('div', [_vm._v("\n    please switch to the rinkeby network.\n  ")]) : (!_vm.account) ? _c('div', [_vm._v("\n    no account found. do you need to unlock metamask?\n  ")]) : _c('div', [_c('register'), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin": "2rem 0"
    }
  }), _vm._v(" "), _c('create-proposal'), _vm._v(" "), _c('h3', [_vm._v("Proposals")]), _vm._v(" "), _c('proposals')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c400930"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/Home.vue
// module id = 259
// module chunks = 1